import React from "react";
import { Link } from "react-router-dom";
import { utils } from "../../../core/helpers";
import { LevelGroup, ActiveIndices, ContentSection } from "../types";

interface Props {
    isLoading: boolean;
    isTopicOnlyMode: boolean;
    isChatMode: boolean;
    successPercentage: number;
    groupedSectionsByLevel: LevelGroup[];
    activeContentId: number | null;
    activeContentIndices: ActiveIndices | null;
    handleTopicSelect: (topic: ContentSection, lIndex: number, sIndex: number) => void;
    handleContentSelect: (content: any, sections: ContentSection[], lIndex: number, sIndex: number, cIndex: number) => void;
}

const CourseSidebar: React.FC<Props> = ({
                                            isLoading,
                                            isTopicOnlyMode,
                                            isChatMode,
                                            successPercentage,
                                            groupedSectionsByLevel,
                                            activeContentId,
                                            activeContentIndices,
                                            handleTopicSelect,
                                            handleContentSelect
                                        }) => {

    const handleBackClick = () => {
        utils.deleteStore("selectedLevel");
        utils.deleteStore("selectedCategory");
        window.location.reload();
    };

    const isSpecialMode = isTopicOnlyMode || isChatMode;

    return (
        <div className="col-lg-4 border-end">
            <div className="progress-overview-section">
                <div className="mb-4">
                    <Link
                        to="#"
                        className="back-to-course"
                        onClick={handleBackClick}
                    >
                        <i className="isax isax-arrow-left me-1" />
                        Change Level/Skill
                    </Link>
                </div>

                {!isSpecialMode && (
                    <div className="mb-4">
                        <p className="mb-1">
                            {successPercentage.toFixed(0)}% Complete
                        </p>
                        <div
                            className="progress progress-xs mb-2"
                            role="progressbar"
                        >
                            <div
                                className="progress-bar bg-success"
                                style={{ width: successPercentage + "%" }}
                            />
                        </div>
                    </div>
                )}

                <div className="accordions-items-seperate" id="accordionLevelExample">
                    {isLoading ? (
                        <p>Loading course content...</p>
                    ) : groupedSectionsByLevel.length > 0 ? (
                        groupedSectionsByLevel.map((levelGroup, levelIndex) => (
                            <div className="accordion-item" key={levelGroup.levelValue}>
                                <div className="accordion-header" id={`headingLevel${levelIndex}`}>
                                    <div
                                        className={`accordion-button ${
                                            levelIndex !== activeContentIndices?.levelIndex &&
                                            !(isSpecialMode && activeContentId && levelGroup.sections.find(s => s.id === activeContentId))
                                                ? "collapsed"
                                                : ""
                                        }`}
                                        role="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#collapseLevel${levelIndex}`}
                                        aria-expanded={levelIndex === activeContentIndices?.levelIndex}
                                        aria-controls={`collapseLevel${levelIndex}`}
                                    >
                                        <div>
                                            <h5 className="mb-0">{levelGroup.levelName}</h5>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    id={`collapseLevel${levelIndex}`}
                                    className={`accordion-collapse collapse ${
                                        levelIndex === activeContentIndices?.levelIndex ||
                                        (isSpecialMode && (levelIndex === 0 || (activeContentId && levelGroup.sections.find(s => s.id === activeContentId))))
                                            ? "show"
                                            : ""
                                    }`}
                                    aria-labelledby={`headingLevel${levelIndex}`}
                                    data-bs-parent="#accordionLevelExample"
                                >
                                    <div className="accordion-body p-0">
                                        {isSpecialMode ? (
                                            <div className="p-3">
                                                {levelGroup.sections.map((section, sectionIndex) => (
                                                    <div
                                                        className={`d-flex align-items-center justify-content-between mb-3 course-watch-content-item ${
                                                            section.id === activeContentId ? "active" : ""
                                                        }`}
                                                        key={section.id}
                                                        onClick={() => handleTopicSelect(section, levelIndex, sectionIndex)}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <div className="d-flex align-items-center">
                                                            <span className="d-flex">
                                                                <i className={`isax ${isChatMode ? 'isax-message-text' : 'isax-book'} fs-24 me-2`} />
                                                            </span>
                                                            <p
                                                                className="accordian-content mb-0"
                                                                style={
                                                                    section.id === activeContentId
                                                                        ? { fontWeight: "bold", color: "var(--bs-primary)" }
                                                                        : {}
                                                                }
                                                            >
                                                                {section.name}
                                                            </p>
                                                        </div>
                                                        <i className="isax isax-arrow-right-3 text-muted" style={{fontSize: '14px'}}></i>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="accordions-items-seperate" id={`accordionSections${levelIndex}`}>
                                                {levelGroup.sections.map((section, sectionIndex) => (
                                                    <div className="accordion-item" key={section.id}>
                                                        <div className="accordion-header" id={`heading${section.id}`}>
                                                            <div
                                                                className={`accordion-button ${
                                                                    levelIndex !== activeContentIndices?.levelIndex ||
                                                                    sectionIndex !== activeContentIndices?.sectionIndex
                                                                        ? "collapsed"
                                                                        : ""
                                                                }`}
                                                                role="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target={`#collapse${levelGroup.levelValue}-${section.id}`}
                                                                aria-expanded={
                                                                    levelIndex === activeContentIndices?.levelIndex &&
                                                                    sectionIndex === activeContentIndices?.sectionIndex
                                                                }
                                                                aria-controls={`collapse${levelGroup.levelValue}-${section.id}`}
                                                            >
                                                                <div>
                                                                    <h6 className="mb-0">{section.name}</h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            id={`collapse${levelGroup.levelValue}-${section.id}`}
                                                            className={`accordion-collapse collapse ${
                                                                levelIndex === activeContentIndices?.levelIndex &&
                                                                sectionIndex === activeContentIndices?.sectionIndex
                                                                    ? "show"
                                                                    : ""
                                                            }`}
                                                            aria-labelledby={`heading${section.id}`}
                                                            data-bs-parent={`#accordionSections${levelIndex}`}
                                                        >
                                                            <div className="accordion-body">
                                                                {section.contents.map((content: any, contentIndex: number) => (
                                                                    <div
                                                                        className={`d-flex align-items-center justify-content-between mb-3 course-watch-content-item ${
                                                                            content.id === activeContentId ? "active" : ""
                                                                        }`}
                                                                        key={content.id}
                                                                        onClick={() =>
                                                                            handleContentSelect(
                                                                                content,
                                                                                levelGroup.sections,
                                                                                levelIndex,
                                                                                sectionIndex,
                                                                                contentIndex
                                                                            )
                                                                        }
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        <div className="d-flex align-items-center">
                                                                            <span className="d-flex">
                                                                              <i
                                                                                  className={`isax ${
                                                                                      content.is_solved
                                                                                          ? "isax-tick-circle text-success"
                                                                                          : "isax-play-circle5"
                                                                                  } fs-24 me-2`}
                                                                              />
                                                                            </span>
                                                                            <p
                                                                                className="accordian-content mb-0"
                                                                                style={
                                                                                    content.id === activeContentId
                                                                                        ? { fontWeight: "bold", color: "var(--bs-primary)" }
                                                                                        : {}
                                                                                }
                                                                            >
                                                                                {content.title}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p>No content is available for this course.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CourseSidebar;